import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-sklton-loader',
  templateUrl: './table-sklton-loader.component.html',
  styleUrls: ['./table-sklton-loader.component.scss'],
})
export class TableSkltonLoaderComponent implements OnInit {
  @Input() displayedColumns: string[] = [];

  products: any[] = [];

  ngOnInit() {
    this.products = Array.from({ length: 5 }).map((_, i) => `Item #${i}`);
  }
}
